import { useEffect } from 'react';

const BottomSheet = ({ open, onClose, title, description, children, footer }) => {
  useEffect(() => {
    if (!open) return undefined;
    const original = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = original;
    };
  }, [open]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-40 flex items-end justify-center bg-stone-950/50 sm:items-center">
      <button
        type="button"
        className="absolute inset-0 h-full w-full cursor-default"
        aria-label="Close sheet"
        onClick={onClose}
      />
      <div className="relative z-10 flex max-h-[92vh] w-full flex-col overflow-hidden rounded-t-[32px] bg-white shadow-2xl sm:max-w-lg sm:rounded-[32px]">
        <div className="flex items-start justify-between gap-3 border-b border-stone-100 px-5 py-4">
          <div className="min-w-0">
            <h2 className="truncate text-lg font-semibold text-stone-950">{title}</h2>
            {description ? (
              <p className="mt-1 text-sm text-stone-500">{description}</p>
            ) : null}
          </div>
          <button
            type="button"
            onClick={onClose}
            className="min-h-[44px] min-w-[44px] rounded-full border border-stone-200 text-lg font-semibold text-stone-700 transition hover:bg-stone-50"
            aria-label="Close"
          >
            ×
          </button>
        </div>
        <div className="flex-1 overflow-y-auto px-5 py-4">{children}</div>
        {footer ? (
          <div className="border-t border-stone-100 bg-white px-5 py-4 pb-[calc(env(safe-area-inset-bottom)+1rem)]">
            {footer}
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default BottomSheet;
